<template>
  <div style="overflow:hidden;" class="mainbox">
    <div class="rolebox">
      <div class="roleleftbox">
        <dl class="roleleftdl">
          <dt>职业/标签</dt>
          <dd @click="gotorolelist" v-for="(item,index) in leftroledata" :key="index">{{item.name}}</dd>
          <!-- <dd>游戏发烧友</dd>
          <dd>网络运营者</dd>
          <dd>程序员</dd>
          <dd>乐迷</dd>
          <dd>家庭煮fu</dd>
          <dd>宝妈/奶爸</dd>
          <dd>学生党</dd>
          <dd>产品经理</dd>
          <dd>摄影爱好者</dd>
          <dd>网购达人</dd>
          <dd>旅人/驴友</dd>
          <dd>自媒体人</dd>
          <dd>影剧粉</dd>
          <dd>新闻君</dd>
          <dd>求职/职场人</dd>
          <dd>医生/病患</dd> -->
        </dl>
      </div>
      <div class="rolerightbox">
        <div class="rolerightmain">
          <div class="roletopbox">
            <div class="rolebanner" id="rolebanner">
              <Carousel v-model="value1" autoplay >
                <CarouselItem>
                  <div class="demo-carousel">
                    <img id="idimg01" :src="banner01" />
                    <div class="titlebox">武汉加油，中国加油</div>
                  </div>
                </CarouselItem>
                <CarouselItem>
                  <div class="demo-carousel">
                    <img id="idimg02" :src="banner02" />
                    <div class="titlebox">最新科技前沿</div>
                  </div>
                </CarouselItem>
                <CarouselItem>
                  <div class="demo-carousel">
                    <img id="idimg01" :src="banner01" />
                    <div class="titlebox">武汉加油，中国加油</div>
                  </div>
                </CarouselItem>
                
              </Carousel>
            </div>
            <div class="aweekbox">
              <div class="aweekmainbox">
                  <h3>一周热门职业/标签榜</h3>
                  <dl  @click="gotorolelist(item.id)" v-for="(item,index) in tagWeekRankList" :key="index">
                      <dt>{{index+1}}.{{item.name}}</dt>
                      <dd><Progress :percent="item.clicks" :stroke-color="item.bgColor" status="active" hide-info/></dd>
                  </dl> 
                  <!-- <dl @click="gotorolelist">
                      <dt>2.网购达人</dt>
                      <dd><Progress :percent="45" stroke-color="#f98b20"  status="active" hide-info/></dd>
                  </dl> 
                  <dl>
                      <dt>3.网络运营者</dt>
                      <dd><Progress :percent="50" stroke-color="#6cd100"  status="active" hide-info/></dd>
                  </dl>
                  <dl>
                      <dt>4.程序员</dt>
                      <dd><Progress :percent="35" stroke-color="#516760"  status="active" hide-info/></dd>
                  </dl>
                  <dl>
                      <dt>5.产品经理</dt>
                      <dd><Progress :percent="20" stroke-color="#70b5dc"  status="active" hide-info/></dd>
                  </dl>
                  <dl>
                      <dt>6.游戏发烧友</dt>
                      <dd><Progress :percent="60" stroke-color="#ff0042"  status="active" hide-info/></dd>
                  </dl>
                  <dl>
                      <dt>7.乐迷</dt>
                      <dd><Progress :percent="71" stroke-color="#7a46ff"  status="active" hide-info/></dd>
                  </dl>
                  <dl>
                      <dt>8.家庭煮fu</dt>
                      <dd><Progress :percent="36" stroke-color="#ecb122"  status="active" hide-info/></dd>
                  </dl> -->
                  

              </div>
            </div>
          </div>


          <div class="rolesslistbox">
              <h3>职业/标签</h3>  
              <div class="rolesslistmain">
                  <ul>
                    <li v-for="(item,index) in righttaglist" :key="index">
                      <dl @click="gotorolelist(item.id)">
                          <dt><img :src="baseURL+'/v1'+item.cover"/></dt>
                          <dd class="fdtitle">{{item.name}}</dd>
                          <dd class="fdlogo" :style="'background-color:'+item.bgColor"><i><img :src="rolelogo"/></i><em>{{item.abbreviation}}</em></dd>
                      </dl>  
                    </li>

                    <!-- <li>
                      <dl @click="gotorolelist">
                          <dt><img :src="role002"/></dt>
                          <dd class="fdtitle">游戏发烧友</dd>
                          <dd class="fdlogo" style="background-color:#ff0042"><i><img :src="rolelogo"/></i><em>游戏</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl @click="gotorolelist">
                          <dt><img :src="role003"/></dt>
                          <dd class="fdtitle">网络运营者</dd>
                          <dd class="fdlogo" style="background-color:#6cd100"><i><img :src="rolelogo"/></i><em>运营</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl @click="gotorolelist">
                          <dt><img :src="role004"/></dt>
                          <dd class="fdtitle">程序员</dd>
                          <dd class="fdlogo" style="background-color:#516760"><i><img :src="rolelogo"/></i><em>程序</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl @click="gotorolelist">
                          <dt><img :src="role005"/></dt>
                          <dd class="fdtitle">乐迷</dd>
                          <dd class="fdlogo" style="background-color:#7a46ff"><i><img :src="rolelogo"/></i><em>音乐</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl @click="gotorolelist">
                          <dt><img :src="role006"/></dt>
                          <dd class="fdtitle">家庭煮fu</dd>
                          <dd class="fdlogo" style="background-color:#ecb122"><i><img :src="rolelogo"/></i><em>煮饭</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role007"/></dt>
                          <dd class="fdtitle">宝妈/奶爸</dd>
                          <dd class="fdlogo" style="background-color:#ea2574"><i><img :src="rolelogo"/></i><em>妈爸</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role008"/></dt>
                          <dd class="fdtitle">学生党</dd>
                          <dd class="fdlogo" style="background-color:#1dc05a"><i><img :src="rolelogo"/></i><em>师生</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role009"/></dt>
                          <dd class="fdtitle">产品经理</dd>
                          <dd class="fdlogo" style="background-color:#70b5dc"><i><img :src="rolelogo"/></i><em>产品</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role0010"/></dt>
                          <dd class="fdtitle">摄影爱好者</dd>
                          <dd class="fdlogo" style="background-color:#4083de"><i><img :src="rolelogo"/></i><em>摄影</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role0011"/></dt>
                          <dd class="fdtitle">网购达人</dd>
                          <dd class="fdlogo" style="background-color:#f98b20"><i><img :src="rolelogo"/></i><em>购物</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role0012"/></dt>
                          <dd class="fdtitle">旅人/驴友</dd>
                          <dd class="fdlogo" style="background-color:#acbb49"><i><img :src="rolelogo"/></i><em>旅游</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role0013"/></dt>
                          <dd class="fdtitle">自媒体人</dd>
                          <dd class="fdlogo" style="background-color:#c204c9"><i><img :src="rolelogo"/></i><em>媒体</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role0014"/></dt>
                          <dd class="fdtitle">影剧粉</dd>
                          <dd class="fdlogo" style="background-color:#0a32df"><i><img :src="rolelogo"/></i><em>影视</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role0015"/></dt>
                          <dd class="fdtitle">新闻君</dd>
                          <dd class="fdlogo" style="background-color:#09d8b8"><i><img :src="rolelogo"/></i><em>资讯</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role0016"/></dt>
                          <dd class="fdtitle">求职/在职人</dd>
                          <dd class="fdlogo" style="background-color:#cea840"><i><img :src="rolelogo"/></i><em>医患</em></dd>
                      </dl>  
                    </li>

                    <li>
                      <dl>
                          <dt><img :src="role0017"/></dt>
                          <dd class="fdtitle">医生/病患</dd>
                          <dd class="fdlogo" style="background-color:#0aafdf"><i><img :src="rolelogo"/></i><em>医患</em></dd>
                      </dl>  
                    </li> -->

                  </ul>    

              </div>
          </div>




        </div>
      </div>
    </div>
    <div class="footerbox"></div>
    <div class="addwebbox">
      <addweb>
      </addweb>
    </div>
    <BackTop :bottom="200" :right="25"></BackTop>
  </div>
</template>

<script>
import addweb from "../publish/addweb";
import axios from 'axios'
// import { getlistSimple,gettaglist } from "../../api/api";
export default {
  components: { addweb },
  data() {
    return {
      value1: 0,
      banner01: require("@/assets/images/banner01.jpg"),
      banner02: require("@/assets/images/banner02.jpg"),
      role001: require("@/assets/images/role001.jpg"),
      role002: require("@/assets/images/role002.jpg"),
      role003: require("@/assets/images/role003.jpg"),
      role004: require("@/assets/images/role004.jpg"),
      role005: require("@/assets/images/role005.jpg"),
      role006: require("@/assets/images/role006.jpg"),
      role007: require("@/assets/images/role007.jpg"),
      role008: require("@/assets/images/role008.jpg"),
      role009: require("@/assets/images/role009.jpg"),
      role0010: require("@/assets/images/role0010.jpg"),
      role0011: require("@/assets/images/role0011.jpg"),
      role0012: require("@/assets/images/role0012.jpg"),
      role0013: require("@/assets/images/role0013.jpg"),
      role0014: require("@/assets/images/role0014.jpg"),
      role0015: require("@/assets/images/role0015.jpg"),
      role0016: require("@/assets/images/role0016.jpg"),
      role0017: require("@/assets/images/role0017.jpg"),      
      rolelogo: require("@/assets/images/alirolelogo.png"), 
      leftroledata:[],
      righttaglist:[],
      baseURL:axios.defaults.baseURL,  
      tagWeekRankList:[]
    };
  },
  created() {
    window.scrollTo(0, 0);
    //console.log('axios.defaults.baseURL',axios.defaults.baseURL)
    
    //左边导航
    getlistSimple().then(res=>{
      if(res.code==200){
        this.leftroledata = res.data;
      }
      console.log('res',res)
    })
    //右边分类
    gettaglist().then(res=>{
      if(res.code==200){
          this.righttaglist = res.data.tagList;
          this.tagWeekRankList=res.data.tagWeekRankList
      }
       console.log('gettaglist',res)
    })
  },
  mounted() {
   
  },
  methods: {
    gotolabeldetails() {
      this.$router.push({
        name: "labeldetails"
      });
    },
    gotorolelist(id){
      this.$router.push({
        name: "rolelist",
        query:{id}
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox {
  padding-top: 60px;
}
.rolebox {
  .roleleftbox {
    float: left;
    width: 250px;
    padding-top: 30px;
    .roleleftdl{ position: fixed; top:87px;}
    dl {
      padding-left: 75px;
      dt {
        font-size: 17px;
        font-weight: bold;
      }
      dd {
        font-size: 15px;
        color: #333;
        margin-top: 10px; cursor: pointer; color: #333;
      }
      dd:hover{ color:#ffa200; }
    }
  }
  .rolerightbox {
    padding-left: 250px;
    .rolerightmain {
      max-width: 1300px; margin-left: 50px;transition:0.5s;
      .roletopbox {
        padding-top: 33px;overflow: hidden; padding-left: 10px; padding-right: 15px;
        .rolebanner {
          float: left;
          width:800px;
          float: left;transition:0.5s;
          
          .ivu-carousel-item{ width: 100%;
              .demo-carousel{ width: 100%; position: relative;
                  .titlebox{ width: 100%; height: 50px; background:rgba(0,0,0,0.3); position: absolute; text-align: left; bottom: 0; z-index: 50; line-height: 50px; font-size: 15px; color: #fff; text-indent: 20px;}
              }
          }
          img {
            width:800px;transition:0.5s;display: block;
          }
        }
        .aweekbox {
          padding-left: 838px;transition:0.5s;
          .aweekmainbox{transition:0.5s;
              h3{ font-size:18px; font-weight: bold;}
              dl{ overflow: hidden; padding-top: 18px; cursor: pointer;
                dt{ float: left; width: 120px; font-size: 15px; }
                dd{ padding-left: 120px;}
              }
          } 
        }
      }

     .rolesslistbox{ padding-top: 30px; overflow: hidden; padding-bottom: 30px;
        h3{ font-size: 21px; font-weight: bold; padding-left: 10px;}
        .rolesslistmain{
            padding-top: 20px;
            ul{
              li{

                padding-top: 15px; padding-bottom: 20px; float: left; width: 33.33333%;

                dl{
                  position: relative; max-width: 421px; border-radius: 10px; overflow: hidden; max-height: 179px; cursor: pointer;transition:0.5s; top:0; width: 95%; margin: 0 auto;
                  dt{overflow: hidden;height: 100%; padding: 0; margin: 0;
                     img{ width:100%;height: 100%;} 
                  }
                  .fdtitle{ position: absolute; width: 100%; top:33%;text-align: center; color: #fff; font-size: 30px; font-weight: bold; z-index: 10;}

                  .fdlogo{ position: absolute; z-index: 5; top:0; left: 0; width: 80px;height: 36px; border-radius: 0 0 30px 0;transition:0.5s;
                      i{float: left; padding-left: 10px; padding-top: 8px;}
                      em{float: left; color: #fff; padding-top: 8px; padding-left: 5px; font-size: 13px;}
                  
                  }


                }
      
              dl:hover{
                top:-5px; box-shadow: 0px 0px 5px #888888;
                .fdlogo{ position: absolute; top:0; left: 0; width: 120%; height: 210%; border-radius: 0 0 100px 0; 
                  opacity: 0.8;                     
                  
                  }

              }


                
              }
            }


        }
     } 


    }


     @media screen and (max-width: 1450px) {  
      .rolerightmain{ margin-left:0;

     .roletopbox {
        padding-top: 33px;overflow: hidden; padding-left: 10px; padding-right: 15px;
        .rolebanner {
          float: left;
          width:800px;
          float: left;          
          img {
            width:100%;
          }
        }
        .aweekbox {
          padding-left:820px;
          .aweekmainbox{ height: 349px; overflow: hidden;
              h3{ font-size:16px; font-weight: bold;}
              dl{ overflow: hidden;  padding-top: 18px;
                dt{ float: left; width: 110px; font-size: 15px; }
                dd{ padding-left: 110px;}
              }
          } 
        }
      }

      
       }
    }  


    @media screen and (max-width: 1300px) {  
      .rolerightmain{ margin-left:0;

     .roletopbox {
        padding-top: 33px;overflow: hidden; padding-left: 10px; padding-right: 15px;
        
        .aweekbox {
          padding-left:820px;
          .aweekmainbox{overflow: hidden;
              h3{ font-size:15px; font-weight: bold;}
              dl{ overflow: hidden;  padding-top: 18px;
                dt{ float: left; width: 110px; font-size: 15px; }
                dd{ padding-left: 110px;}
              }
          } 
        }
      }

      
       }
    } 


     @media screen and (max-width: 1260px) {  
      .rolerightmain{ margin-left:0;

     .roletopbox {
        padding-top: 33px;overflow: hidden; padding-left: 10px; padding-right: 15px;
        
        .aweekbox {
          padding-left:820px;
          .aweekmainbox{overflow: hidden;
              h3{ font-size:13px; font-weight: bold;}
              dl{ overflow: hidden; padding-top: 17px;
                dt{ float: left; width: 110px; font-size: 15px; }
                dd{ padding-left: 110px;}
              }
          } 
        }
      }

      
       }
    } 

    


  }
}

.footerbox {
  height: 60px;
}

.addwebbox {
  right: 30px;
  position: fixed;
  top: 38%;
}
@media screen and (max-width: 1300px) {
  .addwebbox {
    right: 15px;
    position: fixed;
    top: 38%;
  }
}


      
   




</style>



// WEBPACK FOOTER //
// src/components/pages/role.vue